// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__zpcvM","appList":"NavBar_appList__oDwcV","userPanel":"NavBar_userPanel__SVSGw"};